import React, { ChangeEvent, useEffect, useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography
} from '@mui/material'
import { GridRowModel } from '@mui/x-data-grid'

/* Derived from https://mui.com/x/react-data-grid/editing/ */
export default function DialogInputConfirmation(
  props: IDialogInputConfirmationProps
) {
  const {
    promiseArguments,
    setPromiseArguments,
    getConfirmationMessage,
    dialogConfirmation
  } = props

  const [dialogText, setDialogText] = useState<string>('')
  const [paymentInput, setPaymentInput] = useState<string>('')

  useEffect(() => {
    if (!promiseArguments) {
      return
    }

    const { newRow, oldRow } = promiseArguments
    setDialogText(getConfirmationMessage(newRow, oldRow))
  }, [promiseArguments])

  const handleNo = () => {
    if (promiseArguments) {
      setPaymentInput('')
      const { oldRow, resolve } = promiseArguments
      resolve(oldRow)
      setPromiseArguments(null)
    }
  }

  const handleYes = () => {
    if (paymentInput.length) {
      dialogConfirmation(paymentInput)
      setPaymentInput('')
    }
  }

  const paymentInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target
    setPaymentInput(value)
  }

  return (
    <Dialog maxWidth='xs' open={!!promiseArguments}>
      <DialogTitle>Are you sure?</DialogTitle>
      <DialogContent dividers>
        <Typography>{dialogText}</Typography>
        <TextField
          required
          id='paymentID'
          label='Required'
          variant='standard'
          fullWidth
          value={paymentInput}
          onChange={paymentInputChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleNo}>No</Button>
        <Button onClick={handleYes} disabled={!paymentInput.length}>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  )
}

interface IDialogInputConfirmationProps {
  promiseArguments?: IPromiseArguments | null
  setPromiseArguments: (arg?: IPromiseArguments | null) => void
  dialogTitle: string
  dialogConfirmation: (paymentID: string) => void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getConfirmationMessage: (...args: any[]) => string
}

interface IPromiseArguments {
  newRow: GridRowModel
  oldRow: GridRowModel
  resolve: (row: GridRowModel) => void
  reject: (row: GridRowModel) => void
}
